import React from 'react';
export function CandidatForm() {
  return <div className="w-full bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden" data-id="element-38">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdRLYT0VfO_LX-YYiSPQlqEqRBbh85E9r9tEh_ECt_v__4ISQ/viewform?embedded=true" width="100%" height="2532" frameBorder="0" marginHeight={0} marginWidth={0} title="Formulaire de candidature" className="w-full" data-id="element-39">
        Chargement du formulaire…
      </iframe>
    </div>;
}